import { render } from "./AppSectionBreadcrumbs.vue?vue&type=template&id=46eb0be8&scoped=true&ts=true&lang=pug"
import script from "./AppSectionBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./AppSectionBreadcrumbs.vue?vue&type=script&lang=ts"

import "./AppSectionBreadcrumbs.vue?vue&type=style&index=0&id=46eb0be8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46eb0be8"]])

export default __exports__